import * as React from 'react'

import { Small } from 'main/ui'
import { Container, FilledStars, labelStyles, Stars } from './Rating.styles'
import { formatLabel } from './util'

interface IProps {
  value: number
  withLabel: boolean
}

const ratingScale = 5

export default function Rating(props: IProps) {
  const { value, withLabel } = props

  return (
    <Container>
      <Stars>
        <FilledStars fillPercentage={fillPercentage(value)} />
      </Stars>
      {withLabel && (
        <Small css={labelStyles} muted>
          {formatLabel(value)}
        </Small>
      )}
    </Container>
  )
}

function fillPercentage(value: number) {
  if (value < 0) return 0
  if (value >= ratingScale) return 1

  const ratio = value / ratingScale

  // Each 10% increment fills a half star
  return Math.round(ratio / 0.1) * 0.1
}

Rating.defaultProps = {
  withLabel: false,
}
